module.exports = __webpack_public_path__ + "media/images/emoticons/danger-c10a079bcc27a7be6f1a3a74d953f2fa.gif";